export default __webpack_public_path__ + "img/bgVUfOQJ.14fa0de0.svg";